export enum TemperatureSystem {
  Fahrenheit,
  Celsius,
  Kelvin
}
